// Süper admin › Tahsilat › Ödenenler › Fatura önizlemesi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.invoicePaperPreview';

export const invoicePaperPreviewGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Fatura önizlemesi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Ödenmiş bir tahsilatın faturasını kesmeden önce kağıt fatura olarak görürsünüz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Fatura önizlemesi'),
    body: t(`${G}.regions.body`, 'Kağıt fatura'),
    footer: t(`${G}.regions.footer`, 'Yazdır ve Faturaya aktar'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne gösterir?'),
      text: t(`${G}.s1.text`, 'Ödenenler sekmesinde fatura simgesiyle (Fatura önizle ve kes) açılır ve kesilecek satış faturasını kağıt fatura görünümünde gösterir. SATICI fatura şirketidir, ALICI tahsilatın müşteri şirketidir. Fatura tarihi ödeme tarihidir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tahsilat kaydında fatura şirketi yoksa (ya da silinmişse) önizleme açılmaz.'),
        t(`${G}.s1.tip2`, 'Satıcının VKN, vergi dairesi ve adresi fatura şirketinin bağlı olduğu panel şirketinden gelir; eksikse panel şirketinin bilgilerini tamamlayın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kalemleri ve toplamları kontrol edin'),
      text: t(`${G}.s2.text`, 'Tahsilat tutarları KDV dahildir; faturadaki KDV hariç birim fiyat ve KDV tutarı bu tutardan hesaplanır. Altta Ara toplam, KDV ve Genel toplam görünür. Fatura henüz kesilmediyse Belge no "Henüz kesilmedi" yazar.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Yazdır / PDF'),
      text: t(`${G}.s3.text`, '"Yazdır / PDF" önizlemeyi yeni bir pencerede açıp yazdırır; yazıcı yerine "PDF olarak kaydet" seçerek PDF alabilirsiniz. Bu düğme fatura kesmez.'),
      tips: [
        t(`${G}.s3.tip1`, 'Pencere açılmazsa tarayıcı açılır pencereyi engelliyor olabilir; bu site için açılır pencerelere izin verin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Faturaya aktar'),
      text: t(`${G}.s4.text`, '"Faturaya aktar" yalnız faturayı keser: fatura şirketinin panelinde müşterinin carisi (VKN ile) bulunur ya da açılır, satış faturası kesilir ve fatura şirketinin normal panel fatura listesine eklenir. E-fatura / e-arşiv gönderimini o şirketin panelinden elle yaparsınız.'),
      tips: [
        t(`${G}.s4.tip1`, 'Başarılı olunca kaydın Fatura sütunu "Fatura kesildi" olur; satırdaki "Fatura şirketinin faturalarına git" ile faturayı açıp e-fatura / e-arşiv olarak gönderebilirsiniz.'),
        t(`${G}.s4.tip2`, 'Hata olursa Fatura sütununda "Hata" görünür ve düğmeyle yeniden denenebilir. Kesilmiş fatura yeniden denemede ikinci kez kesilmez.'),
      ],
    },
  ],
});
